import { Controller } from "stimulus"

export default class extends Controller {
  showHiddenReports() {
    document.getElementById("hidden-reports-table-container").classList.remove("d-none");
    document.getElementById("show-reports-button").classList.add("d-none");
    document.getElementById("visible-reports-table-container").classList.add("d-none");
    document.getElementById("hide-reports-button").classList.remove("d-none");
  }

  hideHiddenReports() {
    document.getElementById("hidden-reports-table-container").classList.add("d-none");
    document.getElementById("show-reports-button").classList.remove("d-none");
    document.getElementById("visible-reports-table-container").classList.remove("d-none");
    document.getElementById("hide-reports-button").classList.add("d-none");
  }
}
